import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { Tag } from "../ui";

const TOM_ACAO = (a) => {
    if (a.includes("desativar") || a.includes("excluir")) return "danger";
    if (a.includes("criar") || a.includes("ativar")) return "success";
    return "neutral";
};

/** Aba "Auditoria" — log de ações do admin/sistema. */
const AdminAuditoria = () => {
    const [logs, setLogs] = useState(null);

    useEffect(() => {
        api.get("/admin/auditoria").then((r) => setLogs(r.data)).catch(() => setLogs([]));
    }, []);

    if (!logs) return <p className="text-muted">Carregando...</p>;
    if (logs.length === 0) return <p className="text-muted">Nenhum registro de auditoria ainda.</p>;

    return (
        <div className="scroll-x">
            <table className="table">
                <thead><tr><th>Quando</th><th>Quem</th><th>Ação</th><th>Detalhe</th><th>Escritório</th></tr></thead>
                <tbody>
                    {logs.map((l) => (
                        <tr key={l.cod_log}>
                            <td className="num" style={{ whiteSpace: "nowrap" }}>{l.quando}</td>
                            <td>{l.ator} <span className="text-muted" style={{ fontSize: 12 }}>({l.tipo_ator})</span></td>
                            <td><Tag tom={TOM_ACAO(l.acao)}>{l.acao}</Tag></td>
                            <td>{l.detalhe || "—"}</td>
                            <td>{l.nome_escritorio || "—"}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminAuditoria;
